@if (paging && paging.show) {
  <div class="paging">
    <!-- prevLink -->
    <!-- icon @@@ make ui-icon -->
    @if (paging.configuration.actionIfNoLink !== 'hide') {
      @switch (paging.configuration.prevLinkElement.type) {
        @case ('icomoon') {
          <i class="prevLink" [ngClass]="paging.configuration.prevLinkElement.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()"></i>
        }
        @case ('fontawesome') {
          <i class="prevLink" [ngClass]="paging.configuration.prevLinkElement.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()"></i>
        }
        @case ('src') {
          <img class="prevLink" [src]="paging.configuration.prevLinkElement.value" [class.link-disabled]="!paging.hasPrevLink" (click)="onClickPrevLink()">
        }
      }
    }
    <!-- values
    ===============================-->
    <!-- paging -->
    @if (paging.configuration.pagingEnabled) {
      <div>
        <span class="current-page">{{paging.currentPage}}</span>
        <span class="separator-cur-total-page">{{paging.configuration.separatorCurTotalPage}}</span>
        <span class="total-page">{{paging.totalPage}}</span>
      </div>
    }
    <!-- the range -->
    @if (paging.configuration.rangeEnabled) {
      <div class="pagination-text">
        <span class="first-of-range">{{paging.firstOfRange}}</span>
        <span class="separator-range">{{paging.configuration.separatorRange}}</span>
        <span class="last-of-range">{{paging.lastOfRange}}</span>
      </div>
    }
    <!-- nexLink -->
    <!-- icon @@@ make ui-icon -->
    @if (paging.configuration.actionIfNoLink !== 'hide') {
      @switch (paging.configuration.nextLinkElement.type) {
        @case ('icomoon') {
          <i class="nextLink" [ngClass]="paging.configuration.nextLinkElement.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()"></i>
        }
        @case ('fontawesome') {
          <i class="nextLink" [ngClass]="paging.configuration.nextLinkElement.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()"></i>
        }
        @case ('src') {
          <img class="nextLink" [src]="paging.configuration.nextLinkElement.value" [class.link-disabled]="!paging.hasNextLink" (click)="onClickNextLink()">
        }
      }
    }
  </div>
}


